



































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { ValidationMessage } from "@/entities"

@Component
export default class ValidationMessageComponent extends Vue {

    @Prop() messages: Array<ValidationMessage>;
    @Prop() show: boolean;
}

